import { CampanhaPedidoResgateAprovadosByCampanhaAction, CampanhaPedidoAprovadosResgateState, CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA } from "domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgate"
import { DispatchReset, PagedReducer, PagedReducerReset } from "base/src/utils/reducerUtil";
import { IPagedListResponse } from "domain/types/global/pagedListResponse";
import { CampanhaPedidoResgateResponse } from "domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgateResponse";

const INITIAL_STATE: CampanhaPedidoAprovadosResgateState = {
    CampanhaPedidoResgateAprovadosByCampanha: undefined,
};

export function CampanhaPedidoResgateAprovadosReducer(
    state = INITIAL_STATE,
    action: CampanhaPedidoResgateAprovadosByCampanhaAction
): CampanhaPedidoAprovadosResgateState {
    switch (action.type) {
        case CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA:
            return PagedReducer(state, "CampanhaPedidoResgateAprovadosByCampanha", action.payload, "CampanhaPedidoResgateID", CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA)
        case DispatchReset(CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA):
            return PagedReducerReset(state, "CampanhaPedidoResgateAprovadosByCampanha", {} as IPagedListResponse<CampanhaPedidoResgateResponse>, "CampanhaPedidoResgateID", CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA)
        default:
            return state;
    }
}
